import { render } from "./HeaderComponent.vue?vue&type=template&id=5c833af0&scoped=true&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=5c833af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c833af0"],['__file',"src/components/HeaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c833af0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c833af0', __exports__)) {
    api.reload('5c833af0', __exports__)
  }
  
  module.hot.accept("./HeaderComponent.vue?vue&type=template&id=5c833af0&scoped=true&ts=true", () => {
    api.rerender('5c833af0', render)
  })

}


export default __exports__